webpackJsonp([18,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(15);


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	// 目的地弹窗
	$.fn.destination = function (opt) {
	    var getCityIndex = function (n) {
	        var index = 0;
	        opt.mapKey.forEach(function (v, i) {
	            if (v.indexOf(n.toLocaleUpperCase()) > -1) {
	                index = i;
	            }
	        });
	        return index;
	    };
	
	    var $this = $(this);
	    var model = ['<div class="hot-city-model" data-selector="hot-city-model">', '    <div class="input-box"><p>支持搜索目的地和酒店名称</p> <i data-selector="close" class="icon iconguanbi"></i></div>', '    <div class="table-header"><a class="select" data-land="inland" href="javascript:void(0);">国内</a><a  data-land="foreign" href="javascript:void(0);">海外</a></div>', '    <div class="table-title">', '    </div>', '    <div class="content">', '    </div>', '</div>'].join('');
	
	    if (!$('body').find('[data-selector="hot-city-model"]').length) {
	        $('body').append(model);
	    }
	
	    var $box = $('[data-selector="hot-city-model"]');
	    var contentHtml = $('<div class="content"></div>');
	    var hots = opt.data[opt.key].hotDestinations;
	    var cities = opt.data[opt.key].cities || [];
	
	    var offset = $this.offset();
	    $box.css({
	        position: 'absolute',
	        left: offset.left,
	        top: offset.top + $this.outerHeight() + 2
	    });
	
	    var titleList = opt.mapKey.slice();
	    titleList = opt.hot ? ['热门'].concat(titleList) : titleList;
	    titleList = titleList.map(function (o, i) {
	        return '<span ' + (i === 0 ? 'class="active"' : '') + '>' + o + '</span>';
	    });
	    titleList.forEach(function (o) {
	        contentHtml.append($('<div><p>暂无目的地</p></div>'));
	    });
	
	    if (opt.hot) {
	        contentHtml.find('div:eq(0)').html(hots.map(function (o) {
	            return '<a href="javascript:;" data-timezone="' + (o.timezone || 8) + '" data-type="' + o.type + '" data-id="' + o.city + '">' + o.cityName + '</a>';
	        }));
	    }
	    cities.forEach(function (o) {
	        var index = getCityIndex(o.name);
	        if (opt.hot) index += 1;
	        var cityInfos = o.cityInfos || [];
	        var cityHtml = cityInfos.map(function (co) {
	            return '<a href="javascript:;" data-timezone="' + (co.timezone || 8) + '" data-type="' + co.type + '" data-id="' + co.id + '">' + co.name + '</a>';
	        });
	        contentHtml.find('div:eq(' + index + ')').append(cityHtml).find('p').remove();
	    });
	
	    $box.find('.content').html(contentHtml.html());
	    $box.find('.content').find('div').hide().eq(0).show();
	    var indexTitle = 0;
	    $box.find('.table-title').html(titleList).on('click', 'span', function () {
	        indexTitle = $(this).index();
	        $(this).addClass('active').siblings().removeClass('active');
	        $box.find('.content').find('div').hide().eq(indexTitle).show();
	    });
	    $this.css({ 'position': 'relative' });
	
	    $this.off().click(function () {
	        //如果显示模糊搜索则不显示
	        if ($('.pre-search').length) {
	            return false;
	        }
	        $box.show();
	    });
	
	    $box.find('.content').off().on('click', 'a', function (e) {
	        opt.clickCallBack && opt.clickCallBack({
	            id: $(this).attr('data-id'),
	            name: $(this).text(),
	            type: $(this).attr('data-type')
	        });
	        $box.find('.content').find('a').removeClass('active');
	        $(this).addClass('active');
	        $box.hide();
	    });
	
	    $box.find('[data-selector="close"]').off().on('click', function () {
	        $box.hide();
	        $box.hide();
	    });
	
	    $box.find('.table-header').off().on('click', 'a', function (e) {
	        var $this = $(this);
	        $this.addClass('select').siblings().removeClass('select');
	        var keyCurrent = $(this).data('land');
	        hots = opt.data[keyCurrent].hotDestinations;
	        cities = opt.data[keyCurrent].cities || [];
	        contentHtml.find('div').html('<p>暂无目的地</p>');
	        if (opt.hot) {
	            contentHtml.find('div:eq(0)').html(hots.map(function (o) {
	                return '<a href="javascript:;" data-timezone="' + (o.timezone || 8) + '" data-type="' + o.type + '" data-id="' + o.city + '">' + o.cityName + '</a>';
	            }));
	        }
	        if (cities.length) {
	            cities.forEach(function (o) {
	                var index = getCityIndex(o.name);
	                if (opt.hot) index += 1;
	                var cityInfos = o.cityInfos || [];
	                var cityHtml = cityInfos.map(function (co) {
	                    return '<a href="javascript:;" data-timezone="' + (co.timezone || 8) + '" data-type="' + co.type + '" data-id="' + co.id + '">' + co.name + '</a>';
	                });
	                contentHtml.find('div:eq(' + index + ')').append(cityHtml).find('p').remove();
	                $box.find('.content').html(contentHtml.html());
	                $box.find('.content').find('div').hide().eq(indexTitle).show();
	            });
	        } else {
	            $box.find('.content').html('<p>暂无目的地</p>');
	        }
	    });
	
	    $(document).on('click.closeDest', function (e) {
	        if ($this.find(e.target).length > 0 || $this[0] === e.target) return;
	        setTimeout(function () {
	            if (!$box.find(e.target).length && !$box.is(':hidden')) {
	                $box.hide();
	            }
	        }, 30);
	    });
	};

/***/ })

});


// WEBPACK FOOTER //
// js/destination.35dc3872.js